import { render, staticRenderFns } from "./ClientSapTable.vue?vue&type=template&id=2177406c"
import script from "./ClientSapTable.vue?vue&type=script&lang=js"
export * from "./ClientSapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports